import { DictionariesService } from "@sa/rep-mdm";
import { uniq } from "../../../../../shared";

export async function getDefaultMark(dictionariesService: DictionariesService) {
  const calendarDictPromise = dictionariesService.getDictionary({
    id: 'slides-calendar-slide12',
    parameters: {},
  });
  const calendarExportDictPromise = dictionariesService.getDictionary({
    id: 'slides-calendar-slide12-export',
    parameters: {},
  });

  const [calendarDict, calendarExportDict] = await Promise.all([calendarDictPromise, calendarExportDictPromise]);

  const calendarItemsPromise = calendarDict.getAll();
  const calendarExportItemsPromise = calendarExportDict.getAll();

  const [calendarItems, calendarExportItems] = await Promise.all([calendarItemsPromise, calendarExportItemsPromise]);

  const calendar = uniq(calendarItems.map(item => Number(item.id)));
  const xlxsCalendar = uniq(calendarExportItems.map(item => Number(item.id)));

  return {calendar, xlxsCalendar};
}